// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Br-z","tupacHeader":"Cr-z","tupacHeader2":"Dr-z","tupacMenu":"Er-z","tupacMenu2":"Fr-z","tupacMain":"Gr-z","tupacMain2":"Hr-z"};